import FarmReportTemplates from './FarmReportTemplates';

export default FarmReportTemplates;
